import { render, staticRenderFns } from "./FriendlyMultiError.vue?vue&type=template&id=971a390a&"
import script from "./FriendlyMultiError.vue?vue&type=script&lang=ts&"
export * from "./FriendlyMultiError.vue?vue&type=script&lang=ts&"
import style0 from "./FriendlyMultiError.vue?vue&type=style&index=0&id=971a390a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports